export const SHOW_LINK_EXCHANGE_LIMIT = 1000
